import { axios, Response } from '../index'

export interface Body {
  name: string
  macroAreaId: string
  posX: number
  posY: number
}

const createPoint = (request: Body): Response<null> => {
  return axios.post(`/v1/body-points`, request)
}

export default createPoint
